import { useEffect, useState } from 'react';
import { Card } from 'antd';
import { useParams } from 'react-router';
import API from '../../../services/API';
import LoaderComponent from '../../Loader';
import FurnishingComponent from './FurnishingComponent';

function FurnishmentDetails({
  furnishmentDetails = {},
  creditCards = {},
  loading,
  // userId,
  refreshAccount,
  userSummary
}) {

  const [furnishingDetails, setFurnishingDetails] = useState(null);
  let { userId } = useParams();

  const getFurnishingDetails = async () => {
    setFurnishingDetails(null);
    const details = await API.getFurnishingDetails({ userId });

    setFurnishingDetails(details);
  }

  useEffect(() => {
    getFurnishingDetails();
  }, [userId]);

  return (
    <>
      {(loading && furnishingDetails === null) || furnishingDetails === null ? (
        <LoaderComponent />
      ) : (
        <Card bordered={false} className="criclebox tablespace mb-16">
          <FurnishingComponent
            bloomFurnishing={furnishingDetails || furnishmentDetails}
            creditCards={creditCards || {}}
            userId={userId}
            userSummary={userSummary}
            refresh={refreshAccount}
            />
        </Card>)}
    </>
  );
}

export default FurnishmentDetails;
